
import { Model } from 'backbone';
import Immutable from 'immutable';

class SignUpModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default SignUpModel;
